import React from "react";
import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import {Box} from "@mui/material";
import {DataGrid, esES} from "@mui/x-data-grid";
import { Tooltip, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
    reportesResources,
} from "../endpoints";

class RevisionReportesWalmart extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            cargando: true,
            cargando_variance:true,
            cargando_conteo_cero:true,
            cargando_high:true,
            columns :[
                { headerName: 'Revisados', field: 'revisados', flex:1, minWidth: 100},
                { headerName: 'En revisión', field: 'en_revision', flex:1, minWidth: 100},
                { headerName: 'Sin revisar', field: 'sin_revisar', flex:1, minWidth: 100},
                {
                    field: "acciones",
                    headerName: "Acciones",
                    sortable: false,
                    width: 100,
                    renderCell: (params) => (
                        <Tooltip title="Ver detalle" arrow>
                            <IconButton
                                color="primary"
                                onClick={() =>{
                                    // Guardamos los datos actuales en sessionStorage
                                    sessionStorage.setItem(
                                        'revisionReportesWalmart',
                                        JSON.stringify({
                                            timestamp: Date.now(),        // Guardamos la hora
                                            data: this.state.rows_todo    // Guardamos la data
                                        })
                                    );

                                    // Navegamos a la página de detalle
                                    this.props.history.push("/mandatorios")}
                                }>
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                    ),
                },
            ],
            rows:[],
            columns_high :[
                { headerName: 'Hora', field: 'inicio', flex:1, minWidth: 100,
                    valueGetter: (params) => params.row.inicio === 'bodega' ? params.row.inicio.toUpperCase() : params.row.inicio,
                },
                { headerName: 'Sku x revisar', field: 'total_filas', flex:1, minWidth: 100},
                { headerName: 'Sku revisados', field: 'total_revisados', flex:1, minWidth: 100},
                {
                    headerName: '% Revisión',
                    field: 'porcentaje_revision',
                    flex:1,
                    minWidth: 120,
                    valueGetter: (params) => {
                        const revisados = params.row.total_revisados || 0;
                        const total = params.row.total_filas || 1; // evitar división por 0
                        return ((revisados / total) * 100).toFixed(1) + '%';
                    }
                },
                {
                    headerName: 'Estado',
                    field: 'estado',
                    flex: 1,
                    minWidth: 100,
                    renderCell: (params) => {
                        const totalRevisado = params.row.total_revisados || 0;
                        const totalFilas = params.row.total_filas || 1;

                        let estado = "";
                        let backgroundColor = "";

                        if (totalRevisado === totalFilas) {
                            estado = "Revisado";
                            backgroundColor = "#d4edda"; // verde claro
                        } else if (totalRevisado > 0) {
                            estado = "En revisión";
                            backgroundColor = "#fff3cd"; // amarillo claro
                        } else {
                            estado = "Sin revisar";
                            backgroundColor = "#f8d7da"; // rojo claro
                        }

                        return (
                            <div style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor,
                                borderRadius: 4
                            }}>
                                {estado}
                            </div>
                        );
                    }
                },
                {
                    field: "acciones",
                    headerName: "Acciones",
                    sortable: false,
                    width: 100,
                    renderCell: (params) => (
                        <Tooltip title="Ver detalle" arrow>
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    // Guardamos los datos actuales en sessionStorage
                                    sessionStorage.setItem(
                                        'revisionReportesWalmart',
                                        JSON.stringify({
                                            timestamp: Date.now(),        // Guardamos la hora
                                            data: this.state.rows_todo    // Guardamos la data
                                        })
                                    );

                                    // Navegamos a la página de detalle
                                    this.props.history.push({pathname:'/high_dollar', date: params.row.inicio})
                                }}>
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                    ),
                },
            ],
            rows_high:[],
            columns_conteo_cero :[
                { headerName: 'Sku x revisar', field: 'conteo_ids', flex:1, minWidth: 100},
                { headerName: 'Teo', field: 'cantidad_teo', flex:1, minWidth: 100},
                { headerName: 'Teo Importe', field: 'valor_teo', flex:1, minWidth: 100},
                { headerName: 'Sku revisados', field: 'revisados', flex:1, minWidth: 100},
                {
                    headerName: '% Revisión',
                    field: 'porcentaje_revision',
                    flex:1,
                    minWidth: 120,
                    valueGetter: (params) => {
                        const revisados = params.row.revisados || 0;
                        const total = params.row.conteo_ids || 1; // evitar división por 0
                        return ((revisados / total) * 100).toFixed(1) + '%';
                    }
                },
                {
                    field: "acciones",
                    headerName: "Acciones",
                    sortable: false,
                    width: 100,
                    renderCell: (params) => (
                        <Tooltip title="Ver detalle" arrow>
                            <IconButton
                                color="primary"
                                onClick={() =>  {
                                    // Guardamos los datos actuales en sessionStorage
                                    sessionStorage.setItem(
                                        'revisionReportesWalmart',
                                        JSON.stringify({
                                            timestamp: Date.now(),        // Guardamos la hora
                                            data: this.state.rows_todo    // Guardamos la data
                                        })
                                    );

                                    // Navegamos a la página de detalle
                                    this.props.history.push("/detalle_diferencia/jerarquia/-1/-1/-1")}}>
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                    ),
                },
            ],
            rows_conteo_cero: [],
            columns_variance :[
                { headerName: 'Departamento', field: 'jerarquia', flex:1, minWidth: 100},
                { headerName: 'Sku x revisar', field: 'total_filas', flex:1, minWidth: 100},
                { headerName: 'Sku revisados', field: 'total_revisado_true', flex:1, minWidth: 100},
                {
                    headerName: '% Revisión',
                    field: 'porcentaje_revision',
                    flex:1,
                    minWidth: 120,
                    valueGetter: (params) => {
                        const revisados = params.row.total_revisado_true || 0;
                        const total = params.row.total_filas || 1; // evitar división por 0
                        return ((revisados / total) * 100).toFixed(1) + '%';
                    }
                },
                {
                    headerName: 'Estado',
                    field: 'estado',
                    flex: 1,
                    minWidth: 100,
                    renderCell: (params) => {
                        const totalRevisado = params.row.total_revisado_true || 0;
                        const totalFilas = params.row.total_filas || 1;

                        let estado = "";
                        let backgroundColor = "";

                        if (totalRevisado === totalFilas) {
                            estado = "Revisado";
                            backgroundColor = "#d4edda"; // verde claro
                        } else if (totalRevisado > 0) {
                            estado = "En revisión";
                            backgroundColor = "#fff3cd"; // amarillo claro
                        } else {
                            estado = "Sin revisar";
                            backgroundColor = "#f8d7da"; // rojo claro
                        }

                        return (
                            <div style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor,
                                borderRadius: 4
                            }}>
                                {estado}
                            </div>
                        );
                    }
                },
                {
                    field: "acciones",
                    headerName: "Acciones",
                    sortable: false,
                    width: 100,
                    renderCell: (params) => (
                        <Tooltip title="Ver detalle" arrow>
                            <IconButton
                                color="primary"
                                onClick={() =>  {
                                    // Guardamos los datos actuales en sessionStorage
                                    sessionStorage.setItem(
                                        'revisionReportesWalmart',
                                        JSON.stringify({
                                            timestamp: Date.now(),        // Guardamos la hora
                                            data: this.state.rows_todo    // Guardamos la data
                                        })
                                    );

                                    // Navegamos a la página de detalle
                                    this.props.history.push("/detalle_diferencia/jerarquia/"+params.row.id+"/0/monto")}}>
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                    ),
                },
            ],
            rows_variance: [],
        }
    }

    consultarDatosRevisar(){
        reportesResources.getReportesParaRevisar().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({cargando:false,rows_todo: result, rows_high:result.high, rows_conteo_cero:result.conteo_cero,
                    rows_variance:result.variance, rows:[
                        {revisados: result.mandatorios["REVISADO"],
                            en_revision: result.mandatorios["EN REVISIÓN"],
                            sin_revisar: result.mandatorios["SIN REVISAR"],
                            contados: result.mandatorios["TOTAL"],
                            id: result.mandatorios["id"],
                        }
                    ]})
            }
            else if (result.status_code === 401){
                this.setState({cargando:false,openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount() {
        //this.consultarDatosRevisar()
        const cachedData = sessionStorage.getItem('revisionReportesWalmart');
        if (cachedData) {
            const { timestamp, data } = JSON.parse(cachedData);

            const maxAge = 5 * 60 * 1000; // 5 minutos en milisegundos
            const isExpired = Date.now() - timestamp > maxAge;

            if (!isExpired) {
                this.setState({ rows_todo: data, cargando:false,rows_high:data.high, rows_conteo_cero:data.conteo_cero,
                    rows_variance:data.variance, rows:[
                        {revisados: data.mandatorios["REVISADO"],
                            en_revision: data.mandatorios["EN REVISIÓN"],
                            sin_revisar: data.mandatorios["SIN REVISAR"],
                            contados: data.mandatorios["TOTAL"],
                            id: data.mandatorios["id"],
                        }
                    ]})
                return; // usamos el cache, no llamamos backend
            }
            this.consultarDatosRevisar();
        } else {
            this.consultarDatosRevisar()
        }
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Revisión reportes
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{border: '2px solid #444444',borderRadius: 2,overflowY: 'auto',boxSizing: 'border-box',
                            p: 2,  width: '100%', display: 'inline-block' }}>
                            <Typography variant="h6" component="h2" sx={{ mb: 2 , marginBottom:3}}>
                                Mandatorios
                            </Typography>
                            <DataGrid
                                rows={this.state.rows}
                                columns={this.state.columns}
                                autoHeight
                                hideFooter
                                loading={this.state.cargando}
                                pageSize={this.state.rows.length}          // todas las filas
                                rowsPerPageOptions={[this.state.rows.length]} // oculta selector
                                disableSelectionOnClick
                                disableColumnMenu
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{border: '2px solid #444444',borderRadius: 2,overflowY: 'auto',boxSizing: 'border-box',
                            p: 2,  width: '100%', display: 'inline-block' }}>
                            <Typography variant="h6" component="h2" sx={{ mb: 2 , marginBottom:3}}>
                                High Dollar
                            </Typography>
                            <DataGrid
                                rows={this.state.rows_high}
                                columns={this.state.columns_high}
                                autoHeight
                                hideFooter
                                loading={this.state.cargando}
                                getRowId={(row) => row.inicio}
                                pageSize={this.state.rows_high.length}          // todas las filas
                                rowsPerPageOptions={[this.state.rows_high.length]} // oculta selector
                                disableSelectionOnClick
                                disableColumnMenu
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            />

                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{border: '2px solid #444444',borderRadius: 2,overflowY: 'auto',boxSizing: 'border-box',
                            p: 2,  width: '100%', display: 'inline-block' }}>
                            <Typography variant="h6" component="h2" sx={{ mb: 2 , marginBottom:3}}>
                                Variance
                            </Typography>
                            <DataGrid
                                rows={this.state.rows_variance}
                                columns={this.state.columns_variance}
                                autoHeight
                                hideFooter
                                loading={this.state.cargando}
                                pageSize={this.state.rows_variance.length}          // todas las filas
                                rowsPerPageOptions={[this.state.rows_variance.length]} // oculta selector
                                disableSelectionOnClick
                                disableColumnMenu
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{border: '2px solid #444444',borderRadius: 2,overflowY: 'auto',boxSizing: 'border-box',
                            p: 2,  width: '100%', display: 'inline-block' }}>
                            <Typography variant="h6" component="h2" sx={{ mb: 2 , marginBottom:3}}>
                                No contado
                            </Typography>
                            <DataGrid
                                rows={this.state.rows_conteo_cero}
                                columns={this.state.columns_conteo_cero}
                                loading={this.state.cargando}
                                autoHeight
                                hideFooter
                                pageSize={this.state.rows_conteo_cero.length}          // todas las filas
                                rowsPerPageOptions={[this.state.rows_conteo_cero.length]} // oculta selector
                                disableSelectionOnClick
                                disableColumnMenu
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default RevisionReportesWalmart;